import React, { Fragment, useState } from 'react';
import Drawer from '../../../../../components/Drawer';
import Button from '../../../../../components/Button';
import Anchor from '../../../../../components/link/Anchor';
import OrderCsMemoDetailDrawer from '../OrderCsMemoDetailDrawer';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  AVAILABLE_ORDER_DETAIL_STATUS_CHECK_ORDER_ITEM_STATUS_LIST,
  ORDER_ITEM_CS_RECEPTION_TYPE,
  ORDER_ITEM_CS_RECEPTION_TYPE_TEXT,
  ORDER_ITEM_STATUS_TEXT,
  ORDER_ITEM_STATUS_TO_DETAIL_STATUS_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setDash } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import './OrderCsMemoListDrawer.scss';

const OrderCsMemoListDrawer = (props) => {
  const { orderItemCsList, orderItemId, onClose, insertOrderItemCsMemoRequest, editOrderItemCsMemoRequest } = props;
  const [showCsMemoDetail, setShowCsMemoDetail] = useState(false);
  const [detailInfo, setDetailInfo] = useState({});

  return (
    <Drawer
      className="order-detail-cs-memo-drawer"
      push={{ distance: 60 }}
      title={
        <Fragment>
          <span>CS 메모 내역</span>
          <Button
            className="cs-memo-write-button"
            isRadius
            color="primary"
            text="CS 메모 작성"
            onClick={() => {
              setDetailInfo({
                orderItemCsId: null,
                receptionType: ORDER_ITEM_CS_RECEPTION_TYPE.PHONE,
                linkUrl: null,
                memo: null,
                isCreate: true,
              });
              setShowCsMemoDetail(true);
            }}
          />
        </Fragment>
      }
      visible={true}
      placement="bottom"
      mask={false}
      onClose={() => onClose()}
    >
      {orderItemCsList.length ? (
        <div className="cs-memo-list-wrap">
          {orderItemCsList.map((item) => (
            <div className="cs-memo-item-wrap" key={item.id}>
              <div className="cs-memo-item">
                <div className="cs-memo-info">
                  <div>
                    <div>
                      <span className="label">처리자 : </span>
                      <span>
                        {item.adminName}({item.adminId})
                      </span>
                    </div>
                    <div>
                      <span className="label">접수처 : </span>
                      <span>{ORDER_ITEM_CS_RECEPTION_TYPE_TEXT[item.receptionType]}</span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span className="label">처리당시 상품 주문 상태 : </span>
                      <span>{ORDER_ITEM_STATUS_TEXT[item.orderItemStatus]}</span>
                      {AVAILABLE_ORDER_DETAIL_STATUS_CHECK_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus) ? (
                        <span>
                          ({setDash(ORDER_ITEM_STATUS_TO_DETAIL_STATUS_TEXT[item.orderItemStatus][item.detailStatus])})
                        </span>
                      ) : null}
                    </div>
                    <div>
                      <span className="label">처리일시 : </span>
                      <span>{setDateFormat(item.createDate, DATE_FORMAT.FULL_DASH_FORMAT)}</span>
                    </div>
                  </div>
                </div>
                <div className="memo">{item.memo}</div>
                <Anchor
                  color="primary"
                  isUnderLine
                  text="편집"
                  onClick={() => {
                    setDetailInfo({
                      orderItemCsId: item.id,
                      receptionType: item.receptionType,
                      linkUrl: item.linkUrl,
                      memo: item.memo,
                    });
                    setShowCsMemoDetail(true);
                  }}
                />
              </div>
              <div className="cs-memo-link-url">
                <div>
                  <div>
                    <span className="label">관련 URL : </span>
                    <span>
                      <Anchor
                        isUnderLine={!!item.linkUrl}
                        color={item.linkUrl ? 'primary' : undefined}
                        text={setDash(item.linkUrl)}
                        href={item.linkUrl}
                        target="_blank"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      <div className="drawer-confirm-button-area">
        <Button color="primary" text="닫기" onClick={() => onClose()} />
      </div>

      {/* CS 메모 등록/편집 drawer */}
      {showCsMemoDetail ? (
        <OrderCsMemoDetailDrawer
          {...detailInfo}
          orderItemId={orderItemId}
          onClose={() => setShowCsMemoDetail(false)}
          insertOrderItemCsMemoRequest={insertOrderItemCsMemoRequest}
          editOrderItemCsMemoRequest={editOrderItemCsMemoRequest}
        />
      ) : null}
    </Drawer>
  );
};

export default OrderCsMemoListDrawer;
